import { isOwnedArtifact } from "@/lib/grant";
import { useExpertsData } from "./use-experts-data";

export const useExpertEditData = ({
  groupUuid,
  kitUuid,
}: {
  groupUuid: string | null;
  kitUuid: string | null;
}) => {
  const { experts } = useExpertsData(groupUuid, kitUuid);
  // Expert kits can include linked experts. Skills, folders, and
  // context belong to the kit's own expert — not experts[0] (name order).
  const expert = experts.find((item) => isOwnedArtifact(item));

  return {
    expert,
    expertUuid: expert?.uuid ?? null,
  };
};
